import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-320">
      <Header data-id="element-321" />
      <main className="flex-grow" data-id="element-322">
        <Outlet data-id="element-323" />
      </main>
      <Footer data-id="element-324" />
    </div>;
}